const IcNextPage = () => {
  return (<svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.87335 4L6.93335 4.94L9.98668 8L6.93335 11.06L7.87335 12L11.8733 8L7.87335 4Z" fill="currentColor"/>
    </svg>
    )
}

export default IcNextPage